var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_2279)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7507 2.16602C7.62119 2.16611 6.50809 2.43632 5.50425 2.95409C4.50041 3.47187 3.63494 4.2222 2.98006 5.14248C2.32518 6.06276 1.89987 7.1263 1.73962 8.24439C1.57937 9.36247 1.68882 10.5027 2.05885 11.5698C2.42887 12.637 3.04874 13.6002 3.86673 14.3791C4.68472 15.158 5.67712 15.73 6.76113 16.0473C7.84514 16.3647 8.98932 16.4182 10.0982 16.2034C11.2071 15.9887 12.2486 15.5118 13.1357 14.8127L16.179 17.856C16.3362 18.0078 16.5467 18.0918 16.7652 18.0899C16.9837 18.088 17.1927 18.0004 17.3472 17.8459C17.5017 17.6914 17.5894 17.4823 17.5913 17.2639C17.5932 17.0454 17.5092 16.8349 17.3574 16.6777L14.314 13.6343C15.1374 12.5899 15.65 11.3347 15.7933 10.0125C15.9366 8.69022 15.7047 7.35437 15.1242 6.15776C14.5437 4.96115 13.6381 3.95215 12.511 3.24621C11.3838 2.54027 10.0807 2.16593 8.7507 2.16602ZM3.33403 9.24935C3.33403 7.81276 3.90472 6.43501 4.92054 5.41919C5.93636 4.40337 7.31411 3.83268 8.7507 3.83268C10.1873 3.83268 11.565 4.40337 12.5809 5.41919C13.5967 6.43501 14.1674 7.81276 14.1674 9.24935C14.1674 10.6859 13.5967 12.0637 12.5809 13.0795C11.565 14.0953 10.1873 14.666 8.7507 14.666C7.31411 14.666 5.93636 14.0953 4.92054 13.0795C3.90472 12.0637 3.33403 10.6859 3.33403 9.24935Z",
    fill: "#7B7B7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_2279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a29f332c8d56bfe5052dc9a589d6d6cf.svg";
export { ForwardRef as ReactComponent };